import { useCallback, useState } from "react";

export const useDocumentAction = <Args extends unknown[]>(
  action: (...args: Args) => Promise<unknown>,
) => {
  const [isPending, setIsPending] = useState(false);

  const run = useCallback(
    async (...args: Args) => {
      setIsPending(true);
      try {
        await action(...args);
      } finally {
        setIsPending(false);
      }
    },
    [action],
  );

  return { isPending, run };
};
